import { inject } from "@angular/core";
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";
import { Router } from "@angular/router";
import { catchError, EMPTY, throwError } from "rxjs";

import { environment } from "../../environments/environment";
import { AuthService } from "./auth.service";
import { SnackbarService } from "../components/snackbar/snackbar.service";

// A page load fires several requests at once; with a dead token they all 401, so only the
// first one signs out and shows a message.
let handlingSessionExpiry = false;

// Sends the user to /login when the backend rejects their token.
export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const backendUrl = environment.interactiveExperienceServiceUrl;
    if (!req.url.startsWith(backendUrl)) return next(req);

    const authService = inject(AuthService);
    const router = inject(Router);
    const snackbarService = inject(SnackbarService);

    return next(req).pipe(
        catchError((error: unknown) => {
            const isSessionExpiry = error instanceof HttpErrorResponse && error.status === HttpStatusCode.Unauthorized;

            if (!isSessionExpiry) return throwError(() => error);

            if (handlingSessionExpiry) return EMPTY;
            handlingSessionExpiry = true;

            snackbarService.show("Your session ended. Please sign in again.", "error");

            const goToLogin = () => void router.navigate(["/login"]).finally(() => (handlingSessionExpiry = false));
            authService.logout().subscribe({ next: goToLogin, error: goToLogin });
            return EMPTY;
        })
    );
};
